__turbopack_context__.v({
  "betaBadgeContainer": "QuickSearchNlpResultsFooter-module__WrHuga__betaBadgeContainer",
  "footerContainer": "QuickSearchNlpResultsFooter-module__WrHuga__footerContainer",
  "footerContent": "QuickSearchNlpResultsFooter-module__WrHuga__footerContent",
  "footerContentInline": "QuickSearchNlpResultsFooter-module__WrHuga__footerContentInline",
  "footerDescription": "QuickSearchNlpResultsFooter-module__WrHuga__footerDescription",
  "footerDescriptionInline": "QuickSearchNlpResultsFooter-module__WrHuga__footerDescriptionInline",
});
